import { Configuration, TeamContext } from "../types/common";
import { getSiteByTeamCode } from "../utils";

const selectTeamContext = () => {
    //return TeamContext.ACADEMY;
    const path = globalThis?.location?.pathname || '';
    const host = globalThis?.location?.hostname || '';

    if (path.includes('/3/') || path.includes('/m/')) {
        return TeamContext.RODINA_3;
    } else if (path.includes('/2/')) {
        return TeamContext.RODINA_2;
    } else if (path.includes('/y/') || path.includes('/youth/')) {
        return TeamContext.RODINA_M;
    } else if (path.includes('/academy/') || host?.includes('academy')) {
        return TeamContext.ACADEMY;
    }

    return TeamContext.RODINA;
}

export const useConfiguration = (asRef: boolean = false): Configuration => {
    const config = { ...globalThis.FCRC_PHP_DATA } as Configuration;
    config.teamName = selectTeamContext();

    switch (config.teamName) {
        case TeamContext.RODINA_2:
            config.seasonId = 22;
            config.tournamentId = 192;
            config.teamId = 135;
            config.seasonUuid = 'f3043e31-128f-4004-9633-93a1ed672be4';
            break;
        case TeamContext.RODINA_3:
            config.seasonId = 21;
            config.tournamentId = 187;
            config.teamId = 724;
            config.seasonUuid = '501b9631-020b-49a1-ad1b-67f55db547c8';
            break;
        case TeamContext.RODINA_M:
            config.seasonId = 18;
            config.tournamentId = 421;
            config.teamId = 204;
            config.seasonUuid = '501b9631-020b-49a1-ad1b-67f55db547c8';
            break;
        case TeamContext.ACADEMY:
            config.seasonId = 18;
            config.tournamentId = 422;
            config.teamId = 3;
            config.seasonUuid = '501b9631-020b-49a1-ad1b-67f55db547c8';

            if (!config.mainScreenConfig) {
                config.mainScreenConfig = {
                    filters: [],
                    table: {
                        topTeams: 3,
                        bottomTeams: 2,
                    },
                    matches: {
                        prevMatches: 2,
                        totalMatches: 6,
                    }
                };
            }
            config.mainScreenConfig.filters = [{
                title: 'ЮФЛ U-17',
                tournamentId: 422,
                seasonId: 18,
                teamId: 3,
            },
            {
                title: 'ЮФЛ U-16',
                tournamentId: 424,
                seasonId: 18,
                teamId: 3,
            },
            {
                title: 'ЮФЛ U-15',
                tournamentId: 425,
                seasonId: 18,
                teamId: 3,
            }];
            break;
        case TeamContext.RODINA:
        default:
            config.teamName = TeamContext.RODINA;
            config.seasonId = 22;
            config.tournamentId = 191;
            config.teamId = 3;
            if (!config.mainScreenConfig) {
                config.mainScreenConfig = {
                    filters: [],
                    table: {
                        topTeams: 3,
                        bottomTeams: 2,
                    },
                    matches: {
                        prevMatches: 2,
                        totalMatches: 6,
                    }
                };
            }
            config.mainScreenConfig.filters = [{
                title: 'Альфа-Банк РПЛ',
                tournamentId: 191,
                seasonId: 22,
                teamId: 3,
            }];
            config.seasonUuid = 'f3043e31-128f-4004-9633-93a1ed672be4';
    }

    config.site = getSiteByTeamCode(config.teamName);

    globalThis.FCRC_PHP_DATA = config;

    if (asRef) {
        return globalThis.FCRC_PHP_DATA as Configuration;
    }

    return { ...globalThis.FCRC_PHP_DATA } as Configuration;
}

export const useTeamContext = () => {
    const config: Configuration = useConfiguration();
    return config?.teamName;
}
